module.exports = __webpack_public_path__ + "static/media/sponcer_PIMS.375ee890.png";